import React, {useState} from 'react';
import {Modal, ModalBody, ModalHeader, ModalFooter, Button} from 'reactstrap';
import {deleteSavedSearch} from 'utils/api/savedSearchesApi';
import {toast} from 'react-toastify';
import {textTruncateByLength} from 'utils/other';
import SpinnerButton from 'components/SpinnerButton';

const DeleteSavedSearchModal = (props) => {
    const {savedSearch, isOpen, toggle, setDeletedSavedSearchId, resetSearchValues, refreshSavedSearches} = props;
    const [deleting, setDeleting] = useState(false);

    const handleDeleteSavedSearch = async() => {
        try {
            setDeleting(true);
            await deleteSavedSearch(savedSearch.id);
            setDeletedSavedSearchId(savedSearch.id);
            refreshSavedSearches(true);
            // setDeleting(false);
            toast.info('Source successfully deleted');
            resetSearchValues();
            toggle();
        } catch(err) {
            setDeleting(false);
            console.log(err);
            // setSavedSearchesLoading(false);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
        }
    };

    // const deleteSavedSearch = async() => {
    //     setDeletingSavedSearch(true);
    //     handleDeleteSavedSearch(savedSearch.id);
    //     setDeletingSavedSearch(false);
    // };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                <strong>Are you sure you want to delete "{textTruncateByLength(savedSearch.sourceName, 30)}"?</strong>
            </ModalHeader>
            <ModalBody>
                <div style={{paddingRight: 25}}>
                    All associated data will be deleted. This action is irreversible.
                </div>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    style={{minWidth: '83.64px'}}
                    onClick={handleDeleteSavedSearch}
                    submitting={deleting}
                    className="btn calltoaction-button"
                    title="Delete"
                >
                    Delete
                </SpinnerButton>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteSavedSearchModal;